import { render, staticRenderFns } from "./WildlifeAdmin.vue?vue&type=template&id=255963db&scoped=true"
import script from "./WildlifeAdmin.vue?vue&type=script&lang=js"
export * from "./WildlifeAdmin.vue?vue&type=script&lang=js"
import style0 from "./WildlifeAdmin.vue?vue&type=style&index=0&id=255963db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255963db",
  null
  
)

export default component.exports